import React from 'react';

type Variant = 'primary' | 'tomato' | 'ghost' | 'quiet';
type Size = 'sm' | 'md';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  leftIcon,
  rightIcon,
  loading,
  children,
  className,
  disabled,
  ...rest
}) => (
  <button
    className={[
      'rr-btn',
      `rr-btn-${variant}`,
      size === 'sm' ? 'rr-btn-sm' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
    disabled={disabled || loading}
    {...rest}
  >
    {loading ? <span className="rr-btn-loader" aria-hidden="true" /> : leftIcon}
    {children}
    {rightIcon}
  </button>
);

export default Button;
